import React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Header from "./components/Header";
import SubmittedData from "./components/SubmittedData";
import OrderHistory from "./components/OrderHistory";
import PersonalData from "./components/PersonalData";
import { useParams } from "react-router-dom";
import { useGetSingleCustomerQuery } from "../../../hooks/CustomerManagement/useGetSingleCustomerQuery";
import Loader from "../../../Components/Loader";
import WalletTransactions from "./components/WalletTransactions";

const CustomerManager = () => {
  const { id } = useParams();
  const { data, isPending } = useGetSingleCustomerQuery(`${id}`);

  return (
    <DashboardLayout title="Customer Management" back={false}>
      <Header />
      {isPending ? (
        <Loader />
      ) : (
        <>
          <div className="flex gap-[20px] ml-[40px] mr-[14px]">
            <div className="w-6/12">
              <PersonalData data={data?.data} />
            </div>
            <div className="w-6/12 mr-[40px]">
              <SubmittedData
                identificationDocUrl={data?.data?.identificationDocUrl}
              />
              <OrderHistory />
            </div>
          </div>
          <WalletTransactions />
        </>
      )}
    </DashboardLayout>
  );
};

export default CustomerManager;
